import { NgModule } from '@angular/core'
import { CommonModule } from '@angular/common'

import { MenuRoutingModule } from './menu-routing.module'
import { MenuComponent } from './menu.component'
import { FormsModule } from '@angular/forms'
import { KetPermissionModule } from '@ketshopweb/ui/permission'
import { NzDropDownModule } from 'ng-zorro-antd/dropdown'
import { NzMenuModule } from 'ng-zorro-antd/menu'
import { NzAlertModule } from 'ng-zorro-antd/alert'
import { NzModalModule } from 'ng-zorro-antd/modal'
import { NestableModule } from '@ketshopweb/ngx-nestable'
import { NzSwitchModule } from 'ng-zorro-antd/switch'
import { NzButtonModule } from 'ng-zorro-antd/button'
import { NzIconModule } from 'ng-zorro-antd/icon'
import { NzToolTipModule } from 'ng-zorro-antd/tooltip'
import { NzTabsModule } from 'ng-zorro-antd/tabs'
import { KetAddMenuPageModule } from '@ketshopweb/ui/add-menu-page'
import { NzRadioModule } from 'ng-zorro-antd'
import { KetPageListModule } from '@ketshopweb/ui/page-list'
import { SortablejsModule } from 'ngx-sortablejs'
import { KetHeadersMenuModule } from '@ketshopweb/ui/headers-menu'
import { KetDisplayMenuModule } from '@ketshopweb/ui/display-menu'
import { KetMoveLayerManuModule } from '@ketshopweb/ui/move-layer-manu'
import { KetDisplayMenuDetailModule } from '@ketshopweb/ui/display-menu-detail'

@NgModule({
  declarations: [MenuComponent],
  imports: [
    CommonModule,
    MenuRoutingModule,
    FormsModule,
    KetPermissionModule,
    NzDropDownModule,
    NzMenuModule,
    NzAlertModule,
    NzModalModule,
    NestableModule,
    NzSwitchModule,
    NzButtonModule,
    NzIconModule,
    NzToolTipModule,
    NzTabsModule,
    KetAddMenuPageModule,
    NzRadioModule,
    KetPageListModule,
    SortablejsModule,
    KetHeadersMenuModule,
    KetDisplayMenuModule,
    KetMoveLayerManuModule,
    KetDisplayMenuDetailModule,
  ],
})
export class MenuModule {}
